import axios from 'axios'

export default class PaymentService {
  apiKey = process.env.VUE_APP_EPAYCO_API_KEY;
  privateKey = process.env.VUE_APP_EPAYCO_PRIVATE_KEY;
  url = 'https://api.secure.payco.co';

  async initSesionCard () {
    const promiseInitSesion = new Promise((resolve, reject) => {
      const body = {
        public_key: this.apiKey,
        private_key: this.privateKey,
      }
      // console.log("BODY 1 : ", body);
      axios
        .post(this.url + '/v1/auth/login', body)
        .then(function (response) {
          // // console.log(response)
          // // console.log(response.data.bearer_token)
          resolve(response.data.bearer_token)
        })
        .catch(function (error) {
          reject(error)
        })
    })
    return promiseInitSesion
  }

  async tokenizacionCard (dataCard, token) {
    const promiseTokenizacion = new Promise((resolve, reject) => {
      const config = {
        headers: {
          'Content-Type': 'application/json',
          type: 'sdk-jwt',
          Accept: 'application/json',
          Authorization: 'Bearer ' + token,
        },
      }
      axios
        .post(this.url + '/v1/tokens', dataCard, config)
        .then(function (response) {
          // // console.log(response)
          // // console.log(response.data.bearer_token)
          resolve(response.data.bearer_token)
        })
        .catch(function (error) {
          reject(error)
        })
    })
    return promiseTokenizacion
  }
}
